import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { queryKeys } from "@/lib/query-keys";
import adminAPI from "@/services/api";

import { createSearchClient } from "../lib/algolia";

/** Scoped Algolia key — mirrors SearchStore.refreshKey (GET /admin/search/key). */
export function useScopedSearchKey() {
  return useQuery({
    queryKey: queryKeys.search.scopedKey,
    queryFn: () => adminAPI.getScopedKey(),
    staleTime: 30 * 60 * 1000,
  });
}

/**
 * Shared Algolia lite client, memoized on the scoped key. Returns `null`
 * until the key is available — gate all search UI on it.
 */
export function useSearchClient() {
  const { data: searchKey, isPending } = useScopedSearchKey();
  const securedApiKey = searchKey?.securedApiKey;

  const client = useMemo(() => (securedApiKey ? createSearchClient(securedApiKey) : null), [securedApiKey]);

  return { client, isPending };
}

/**
 * Client des index de référence (aéroports, compagnies), sur `referenceApiKey` : la clé
 * scopée porte des filtres de dossiers qui, appliqués à ces index, ne renvoient rien aux
 * rôles agence (TECH-1087). Même contrat que `useSearchClient`.
 */
export function useReferenceSearchClient() {
  const { data: searchKey, isPending } = useScopedSearchKey();
  const referenceApiKey = searchKey?.referenceApiKey;

  const client = useMemo(
    () => (referenceApiKey ? createSearchClient(referenceApiKey) : null),
    [referenceApiKey],
  );

  return { client, isPending };
}
